type Props = { size?: number }

/** Left-pointing chevron ("‹"). Rotated by consumers for the other direction. */
const ChevronIcon = ({ size = 18 }: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M8.75 10.5L5.25 7L8.75 3.5"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export default ChevronIcon
